import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import SessionDialog from '../../sessions/components/SessionDialog'

const Field = styled.div`
  margin-bottom: 12px;
`
const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
  margin-bottom: 4px;
`
const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
`
const TextArea = styled.textarea`
  width: 100%;
  min-height: 70px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`

export default function GoalDialog({ open, existing, onClose, onSubmit }) {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [target, setTarget] = useState('')
  const [current, setCurrent] = useState('')
  const [unit, setUnit] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (open) {
      setTitle(existing?.title || '')
      setDescription(existing?.description || '')
      setTarget(existing?.targetValue ?? '')
      setCurrent(existing?.currentValue ?? '')
      setUnit(existing?.unit || '')
    }
  }, [open, existing])

  async function handle() {
    setBusy(true)
    try {
      await onSubmit({
        title: title.trim(),
        description: description.trim() || null,
        targetValue: target === '' ? null : Number(target),
        currentValue: current === '' ? 0 : Number(current),
        unit: unit.trim() || null,
        setBy: existing?.setBy || 'SELF',
      })
      onClose()
    } finally {
      setBusy(false)
    }
  }

  return (
    <SessionDialog
      open={open}
      title={existing ? 'Edit goal' : 'New goal'}
      primaryLabel={existing ? 'Save' : 'Create'}
      primaryDisabled={!title.trim()}
      primaryLoading={busy}
      onPrimary={handle}
      onClose={onClose}
    >
      <Field>
        <Label>Title</Label>
        <Input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. Sleep 7+ hours nightly"
        />
      </Field>
      <Field>
        <Label>Description (optional)</Label>
        <TextArea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="What does success look like?"
        />
      </Field>
      <Row>
        <Field>
          <Label>Target</Label>
          <Input
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            placeholder="7"
            inputMode="decimal"
          />
        </Field>
        <Field>
          <Label>Current</Label>
          <Input
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            placeholder="0"
            inputMode="decimal"
          />
        </Field>
      </Row>
      <Field>
        <Label>Unit</Label>
        <Input
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          placeholder="e.g. nights/week, kg, sessions"
        />
      </Field>
    </SessionDialog>
  )
}
